import React, { useState, useEffect } from 'react';
import Collage from '../../component/Collage';
import './style.css';

import Loader from 'component/Loader';

export default ({ match }) => {
    const [cmsData, setCmsData] = useState(null);
    let Name = match.params.name;
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_DOMAIN}/gallery-pages/${Name}`)
            .then(response => response.json())
            .then(data => {
                setCmsData(data);
            }).catch(error => {
                console.log('Something went wrong');
            })
    }, []);

    if (!cmsData) {
        return <Loader></Loader>
    }

    const { images = [] } = cmsData;

    return <main style={{ "--space": "var(--s1)" }} className="stack-l xl:container mx-auto my-12 md:mt-40 px-4 pb-10 ">
        <h1 className="text-center">Photo Gallery</h1>
        <Collage Images={images}></Collage>
    </main>
}